import { NgModule, Optional, SkipSelf } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { environment } from '@env/environment';

import { LogModule } from '../logging';
import { SharedModule } from '../shared/shared.module';
import { ConfirmationDialogComponent } from './confirm/confirmation-dialog.component';
import { NotificationDialogComponent } from './notify/notification-dialog.component';

@NgModule({
	declarations: [ConfirmationDialogComponent, NotificationDialogComponent],
	imports: [
		LogModule.initializeLogger(environment.logging),
		MatButtonModule,
		MatDialogModule,
		MatSnackBarModule,
		SharedModule,
	],
})
export class CoreModule {
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
		if (parentModule) {
			throw new Error(`CoreModule has already been loaded. Import Core modules in the AppModule only.`);
		}
	}
}
